import * as React from "react"

const Location = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M7.5 2A4.5 4.5 0 0 0 3 6.5c0 .712.185 1.377.48 1.977l4.02 6.08 4.01-6.061c.305-.6.49-1.275.49-1.996A4.5 4.5 0 0 0 7.5 2Zm0 6.45a2.135 2.135 0 1 1 .002-4.271 2.135 2.135 0 0 1-.002 4.27Z" />
  </svg>
)

export default Location
